import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { Card, Modal, Button, Form, InputGroup } from 'react-bootstrap';
import { es } from 'date-fns/locale';
import { useQuery } from '../../../utils/useQuery';
import { useHistory } from 'react-router-dom';
import { handleGraficosParams } from '../../../utils/handleGraficosParams';
import { DesdeButton, HastaButon } from '../DesdeYHastaButtons';
import { useLocation } from 'react-router-dom';
import DatePicker, { registerLocale } from 'react-datepicker';
import apiAxios from '../../../config/ApiAxios';
import 'react-datepicker/dist/react-datepicker.css';
import { parseDate } from '../../../utils/dateFormatter';
import { firstDay, lastDay } from '../../../config/reportesGlobales';

registerLocale('es', es);

const ComportamientoPagosBarras = () => {
	//MODAL
	const [show, setShow] = useState(false);
	const [modalSaved, setModalSaved] = useState(false);
	const handleClose = () => {
		setShow(false);
		setDias(5);
		setMeses(4);
		setAnios(1);
	};
	const handleShow = () => setShow(true);
	const handleSave = () => {
		setModalSaved(!modalSaved);
		setShow(false);
	};

	const [dias, setDias] = useState(5);
	const [meses, setMeses] = useState(4);
	const [anios, setAnios] = useState(1);

	const [series, setSeries] = useState([]);
	const [categories, setCategories] = useState([]);

	const [startDate, setStartDate] = useState(firstDay);
	const [endDate, setEndDate] = useState(lastDay);
	const location = useLocation();

	useEffect(() => {
		const searchParams = new URLSearchParams(location.search);
		const fechaInicio = searchParams.get('fecha-inicio');
		const fechaFinal = searchParams.get('fecha-final');

		if (fechaInicio) {
			const parsedStartDate = parseDate(fechaInicio);
			setStartDate(parsedStartDate);
		}

		if (fechaFinal) {
			const parsedEndDate = parseDate(fechaFinal);
			setEndDate(parsedEndDate);
		}
	}, [location.search]);

	const startDateYear = startDate.getFullYear();
	const startDateMonth = String(startDate.getMonth() + 1).padStart(2, '0');
	const startDateDay = String(startDate.getDate()).padStart(2, '0');

	const endDateYear = endDate.getFullYear();
	const endDateMonth = String(endDate.getMonth() + 1).padStart(2, '0');
	const endDateDay = String(endDate.getDate()).padStart(2, '0');

	useEffect(() => {
		const obtenerCreditos = async () => {
			try {
				const url = `/reportes/global/pagos/comportamiento?fecha_desde=${startDateYear}-${startDateMonth}-${startDateDay}
					&fecha_hasta=${endDateYear}-${endDateMonth}-${endDateDay}
					&agrupar_por[]=comportamiento
					&agrupar_por[]=demora
					&dias_grupo=${dias}
					&meses_grupo=${meses}
					&anios_grupo=${anios}
					`;
				const apiResponse = await apiAxios.get(url);

				if (apiResponse?.status === 200) {
					// Labels con comportamiento y, si aplica, grupo de mora
					const data = apiResponse.data;

					const categories = data.map((item) =>
						item.comportamiento === 'demorado'
							? `${item.comportamiento} - ${item.grupo_mora}`
							: item.comportamiento
					);

					setCategories(categories);

					const series = data.map(
						(item) => item.cantidad_cuotas
					);

					setSeries([
						{
							name: 'cuotas pagas',
							data: series,
						},
					]);
				}
			} catch (e) {
				console.log(e);
			}
		};

		obtenerCreditos();
	}, [
		endDateDay,
		endDateMonth,
		endDateYear,
		startDateDay,
		startDateMonth,
		startDateYear,
		modalSaved,
	]);

	const options = {
		plotOptions: {
			bar: {
				borderRadius: 4,
				borderRadiusApplication: 'end',
				horizontal: true,
			},
		},
		dataLabels: {
			enabled: false,
		},
		xaxis: {
			categories,
		},
	};

	const query = useQuery();
	const history = useHistory();

	const ocultarGrafico = query.get('ocultarGrafico');

	const ocultarGraficoArray = ocultarGrafico
		? ocultarGrafico.replace(/[[\]]/g, '').split(',').map(Number)
		: [];
	return (
		<div
			className="column-card"
			style={{
				display: ocultarGraficoArray.includes(4) ? 'none' : 'block',
			}}>
			<div className="px-2 py-2 border border-bottom-0 d-flex align-items-center gap-1">
				<DatePicker
					locale={'es'}
					selected={startDate}
					onChange={(date) => setStartDate(date)}
					selectsStart
					startDate={startDate}
					endDate={endDate}
					dateFormat={'dd/MM/yyyy'}
					customInput={<DesdeButton className="" />}
					showMonthDropdown
					showYearDropdown
					dropdownMode="select"
					maxDate={'01/01/2040'}
					minDate={'01/01/2010'}
				/>
				<i class="bi bi-arrow-right"></i>
				<DatePicker
					locale={'es'}
					selectsEnd
					selected={endDate}
					onChange={(date) => setEndDate(date)}
					startDate={startDate}
					endDate={endDate}
					minDate={startDate}
					dateFormat={'dd/MM/yyyy'}
					customInput={<HastaButon className="me-3" />}
					showMonthDropdown
					showYearDropdown
					dropdownMode="select"
					maxDate={'01/01/2040'}
				/>

				<Button
					className="ms-auto"
					variant="primary"
					onClick={handleShow}>
					Asignar Grupos
				</Button>
			</div>
			<Card className="custom-card-body">
				<Card.Body>
					<Card.Title>
						Comportamiento de Pago{' '}
						<button
							title="Ocultar"
							className="btn btn-light ms-2"
							onClick={() =>
								handleGraficosParams(
									4,
									ocultarGraficoArray,
									history
								)
							}>
							<i class="bi bi-eye"></i>
						</button>
						<a
							title="Muestra ....."
							className="btn btn-light ms-2"
							disabled>
							<i class="bi bi-info-circle"></i>
						</a>
					</Card.Title>
					<Chart
						type="bar"
						options={options}
						series={series}
						height={'90%'}
						width={800}
					/>
				</Card.Body>
			</Card>
			<Modal centered show={show} onHide={handleClose}>
				<Modal.Header closeButton>
					<Modal.Title>Asignar Grupos</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<InputGroup className="mb-3">
						<InputGroup.Text id="basic-addon1">
							Cada
						</InputGroup.Text>
						<Form.Control
							type="number"
							min={3}
							max={30}
							defaultValue={dias}
							onChange={(e) =>
								setDias(Number(e.target.value))
							}
						/>
						<InputGroup.Text id="basic-addon2">
							Días
						</InputGroup.Text>
					</InputGroup>
					<InputGroup className="mb-3">
						<InputGroup.Text id="basic-addon1">
							Cada
						</InputGroup.Text>
						<Form.Control
							type="number"
							min={1}
							max={12}
							defaultValue={meses}
							onChange={(e) =>
								setMeses(Number(e.target.value))
							}
						/>
						<InputGroup.Text id="basic-addon2">
							Meses
						</InputGroup.Text>
					</InputGroup>
					<InputGroup className="mb-3">
						<InputGroup.Text id="basic-addon1">
							Cada
						</InputGroup.Text>
						<Form.Control
							aria-describedby="basic-addon1"
							type="number"
							min={1}
							defaultValue={anios}
							onChange={(e) =>
								setAnios(Number(e.target.value))
							}
						/>
						<InputGroup.Text id="basic-addon2">
							Años
						</InputGroup.Text>
					</InputGroup>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="primary" onClick={handleSave}>
						Guardar
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
};

export default ComportamientoPagosBarras;
